<template>
    <el-container direction="vertical" class="spreadsheet">
        <el-row type="flex" align="middle" class="spreadsheet-header" justify="space-between">
            <el-col :span="15">
                <div class="spreadsheet-header-title">
                    {{ title }}
                </div>
            </el-col>
            <el-col :span="3">
                <span class="spreadsheet-header-total">
                    Всего записей: {{ pagesInfo.total }}
                </span>
            </el-col>
            <el-col :span="3">
                <el-button class="spreadsheet-header-button" type="warning" @click="goNewCard">
                    новый контрагент
                </el-button>
            </el-col>
            <el-col :span="1" title="Excel" class="icon-excel" v-if="isExcelButtonVisible">
                <div class="spreadsheet-header-excel">
                    &nbsp;
                </div>
            </el-col>
        </el-row>
        <el-row type="flex" align="top" class="spreadsheet-table" v-loading="loading">
            <el-col :span="24">
                <ag-grid-vue
                    class="ag-theme-balham spreadsheet-table-grid"
                    :grid-options="gridOptions"
                    :column-defs="columnDefs"
                />
            </el-col>
        </el-row>
        <el-row type="flex" align="bottom" class="spreadsheet-bar">
            <el-col :span="6">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="pagesInfo.total"
                    :page-size="pageModel.pageSize"
                    :current-page="pageModel.currentPage"
                    :small="true"
                    @current-change="getCurrentPage"
                />
            </el-col>
            <el-col :span="10">
                <div class="spreadsheet-bar-pages">
                    <span class="spreadsheet-bar-pages-title">
                        Выводить по:
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize20}"
                        @click="setPageSize(20)"
                    >
                        20
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize50}"
                        @click="setPageSize(50)"
                    >
                        50
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize100}"
                        @click="setPageSize(100)"
                    >
                        100
                    </span>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="spreadsheet-bar-total">
                    <span>
                        Строк выведено: {{ totalRows }} Из них выделено: {{ selectedRowsCount }}
                    </span>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import TableHeaderSettings from '@/components/TableHeaderSettings';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { pickerOptions } from '@/common/pickerOptions';
import capitalize from 'lodash/capitalize';
import moment from 'moment';
import '@/assets/styles/list.scss';

library.add(faEye);

export default {
    name: 'ContractorsGrid',
    data() {
        return {
            title: 'Список контрагентов',
            isFilterFormVisible: false,
            filterModel: {
                id: null,
                name: null,
                phone: null,
                email: null,
                comment: null
            },
            fieldsNames: {
                id: 'ID',
                name: 'имя контрагента',
                phone: 'телефон',
                email: 'e-mail',
                comment: 'комментарий'
            },
            pageModel: {
                currentPage: 1,
                pageSize: 20
            },
            formLabelWidth: '120px',
            totalRows: 0,
            selectedRowsCount: 0,
            loading: true,
            pickerOptions,
            gridOptions: {
                rowSelection: 'multiple',
                suppressDragLeaveHidesColumns: false,
                suppressPaginationPanel: true,
                suppressLoadingOverlay: true,
                rowDeselection: true,
                enableCellTextSelection: true,
                headerHeight: 50,
                rowHeight: 40,
                domLayout: 'autoHeight',
                onRowDataChanged: this.onRowDataChanged.bind(this),
                onRowSelected: this.onRowSelected.bind(this),
                onColumnResized: this.onColumnResized.bind(this),
                onDisplayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
                onRowDoubleClicked: this.onSelectionChanged.bind(this),
                onSortChanged: this.onSortChanged.bind(this),
                defaultColDef: {
                    sortable: true,
                    filter: false,
                    resizable: true,
                    cellClass: 'column-text',
                    comparator: () => {
                        return 0;
                    }
                }
            },
            columnDefs: [],
            companyOptions: []
        };
    },
    components: {
        'ag-grid-vue': AgGridVue
    },
    computed: {
        contractors() {
            return this.$store.state.contractors.contractors;
        },
        pagesInfo() {
            return this.$store.state.contractors.pages;
        },
        setting() {
            return this.$store.state.preferences.setting;
        },
        companies() {
            return this.$store.state.references.companies;
        },
        isSetPageSize20() {
            return this.pageModel.pageSize === 20;
        },
        isSetPageSize50() {
            return this.pageModel.pageSize === 50;
        },
        isSetPageSize100() {
            return this.pageModel.pageSize === 100;
        },
        filterTitle() {
            let result = '';
            for (const field in this.filterModel) {
                if (Object.prototype.hasOwnProperty.call(this.filterModel, field) && this.filterModel[field]) {
                    const getNamesFrom = (obj) => {
                        if (Object.keys(obj).length !== 0) {
                            return (this.fieldsNames[field] + ': ' + this.filterModel[field].map(id => obj.find(item => item.id === id).name).join(' | ') + '; ');
                        } else {
                            return '';
                        }
                    };
                    if (['string', 'object'].includes(typeof this.filterModel[field]) && this.filterModel[field].length) {
                        switch (field) {
                            case 'company_id':
                                result += getNamesFrom(this.companies);
                                break;
                            default:
                                result += (this.fieldsNames[field] + ': ' + this.filterModel[field] + '; ');
                        }
                    }
                    if (field === 'birthday') {
                        result += this.fieldsNames[field] + ': ' + moment(this.filterModel[field]).format('DD.MM.YYYY') + '; ';
                    }
                }
            }
            return result;
        },
        isExcelButtonVisible() {
            //использовать в задаче реализации экспорта в excel
            return false;
        }
    },
    created() {
        this.columnDefs = [
            {
                headerName: this.fieldsNames.id,
                field: 'id',
                width: 100
            },
            {
                headerName: this.fieldsNames.name,
                field: 'name',
                width: 300
            },
            {
                headerName: this.fieldsNames.phone,
                field: 'phone',
                width: 300
            },
            {
                headerName: this.fieldsNames.email,
                field: 'email',
                width: 300
            },
            {
                headerName: this.fieldsNames.comment,
                field: 'comment'
            }
        ];
    },
    mounted() {
        this.$store.dispatch('preferences/getPreferences').then(
            () => {
                this.setSettings();
            }).catch(() => {
            this.getDataFromServer();
        });
    },
    methods: {
        setSettings() {
            if (this.setting.contractors) {
                this.gridOptions.columnApi.setColumnState(this.setting.contractors.table);
                this.gridOptions.api.setSortModel(this.setting.contractors.sort);
                this.filterModel = JSON.parse(JSON.stringify(this.setting.contractors.filter));
                this.pageModel = JSON.parse(JSON.stringify(this.setting.contractors.page));
            } else {
                this.gridOptions.api.setSortModel({});
            }
        },
        hideFilterForm() {
            this.isFilterFormVisible = false;
        },
        getLinkElement(id, name, route, elementType, className) {
            const element = document.createElement(elementType);
            if (elementType === 'a') {
                element.href = this.$router.resolve(route).href;
                element.innerText = name;
            }
            element.className += ' ' + className;
            element.addEventListener('click', e => {
                e.preventDefault();
                this.$router.push(route);
            });
            return element;
        },
        onSelectionChanged(e) {
            this.$router.push({
                name: 'contractor-card',
                params: { id: '' + e.node.data.id }
            });
        },
        getDataFromServer() {
            const requestParams = {
                size: this.pageModel.pageSize,
                page: this.pageModel.currentPage,
                sort: this.gridOptions.api.getSortModel(),
                filter: this.filterModel
            };
            this.loading = true;
            this.$store.dispatch('contractors/getPaginatedList', requestParams).then(
                response => {
                    this.gridOptions.api.setRowData(this.contractors);
                    this.pageModel.pageSize = +response.data.meta.per_page;
                    this.pageModel.currentPage = response.data.meta.current_page;
                    this.saveSetting();
                    this.loading = false;
                }).catch(
                error => {
                    if (error.response) {
                        this.loading = false;
                    }
                }).finally(() => {
                this.companyOptions = JSON.parse(JSON.stringify(this.companies));
            });
        },
        setPageSize(size) {
            this.pageModel.pageSize = size;
            this.getDataFromServer();
        },
        goNewCard() {
            this.$router.push({ name: 'contractor-card-new' });
        },
        getCurrentPage(page) {
            this.pageModel.currentPage = page;
            this.getDataFromServer();
        },
        filterApplied() {
            this.isFilterFormVisible = false;
            this.pageModel.currentPage = 1;
            this.getDataFromServer();
        },
        onRowDataChanged() {
            this.totalRows = this.gridOptions.api.getDisplayedRowCount();
        },
        onRowSelected() {
            this.selectedRowsCount = this.gridOptions.api.getSelectedRows().length;
        },
        isColumnVisible(colId) {
            return this.isFilterFormVisible && this.gridOptions.columnApi ? this.gridOptions.columnApi.getColumn(colId).visible : false;
        },
        onDisplayedColumnsChanged() {
            this.saveSetting();
        },
        onColumnResized(data) {
            if (data.finished && data.source === 'uiColumnDragged') {
                this.saveSetting();
            }
        },
        onSortChanged() {
            this.getDataFromServer();
        },
        async saveSetting() {
            const data = {
                'contractors': {
                    'table': this.gridOptions.columnApi.getColumnState(),
                    'sort': this.gridOptions.api.getSortModel(),
                    'filter': this.filterModel,
                    'page': this.pageModel
                }
            };
            await this.$store.dispatch('preferences/setPreferences', data);
        },
        capitalize: capitalize
    }
};
</script>
